import React from 'react';
import { FDBodyText } from '@facet-wealth/design';
import Proptypes from 'prop-types';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import { dataAttrs } from 'Helpers/Testing';


export const Disclosure = ({
  value, align = 'start', color = 'textDisabled', richtext, ...rest
}) => {
  if (!value) {
    return null;
  }

  const sharedProps = {
    value,
    color,
    size: 'sm',
    align,
    ...dataAttrs('disclosure'),
    ...rest,
  };

  if (richtext) {
    return (<Richtext
      Component={FDBodyText}
      richtext
      inheritColor
      underlineLink
      {...sharedProps}
    />);
  }


  return <FDBodyText {...sharedProps} />;
};

Disclosure.defaultProps = {
  value: null,
};

Disclosure.propTypes = {
  value: Proptypes.string,
};
